import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelEdit: string;
    itemCount: (count: number) => string | React.ReactNode;
    showShareActionsMenu: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria-label for editing a share name */
            labelEdit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareNavItem.labelEdit?c=2zoghuew208eb", defaultMessage: "Edit Share name" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the share item count */
            itemCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "ShareNavItem.itemCount?c=2w1ns5ikli1g7", defaultMessage: "{count, plural, =0 {No Items} one {1 Item} other {{count} Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria-label for the share actions menu button */
            showShareActionsMenu: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareNavItem.showShareActionsMenu?c=2i2vw96ezuatc", defaultMessage: "Show share actions menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
